import { Button, TableColumnType } from "antd";

export const warningRuleColumn = (
  onclick: (t: string, ruleId: any, name: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      key: "no",
      width: "4rem",
      align: "center",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "主项编码",
    //   dataIndex: "mainCode",
    //   align: "center",
    // },
    {
      title: "主项编码名称",
      dataIndex: "mainName",
      align: "center",
      key: "mainName",
    },
    {
      title: "规则分类",
      dataIndex: "type",
      align: "center",
      key: "type",
      render: (_, r) =>
        r.type === 0 ? "基础类" : r.type === 1 ? "个性类" : "",
      // type	规则分类 [0:基础类 1:个性类]
    },

    {
      title: "操作",
      align: "center",
      width: "300px",
      render: function Element(_, t) {
        return (
          <div>
            <Button
              style={{ marginRight: "15px" }}
              type="primary"
              ghost
              size="small"
              onClick={(e: any) => {
                onclick("look", t.ruleId, t.name);
              }}
            >
              查看详情
            </Button>
            <Button
              type="primary"
              size="small"
              onClick={(e: any) => {
                onclick("uplode", t.ruleId, t.name);
              }}
            >
              算法下载
            </Button>
          </div>
        );
      },
    },
  ];
};
